/* eslint-disable react/prop-types */ // TODO: add props
import WorkedQuestionReview from '../WorkedQuestionReview';
import WorkedChecklistQuestionReview from '../WorkedChecklistQuestionReview';
import { UnsupportedQuestionType } from '../../../components/UnsupportedQuestionType';
import { ChecklistQuestionReview } from '../ChecklistQuestionReview';
import { StaticEquation } from 'edrolo/domains/exams';
import { EXAM_QUESTION_TYPES } from 'edrolo/constants/QuestionTypes';
import {
  NumberOnImageQuestionReview,
  FillInBlankQuestionReview,
  DragAndDropQuestionReview,
  IllustrationQuestionReview,
  CorrectableQuestionReview,
  ComplexSolutionQuestionReview,
} from '../CorrectableQuestionReview';
import {
  name,
  answeredCorrectly,
  selfReflection,
} from '../../../components/TableColumns/TableColumns';
import { ShortAnswerQuestionReview } from '../ShortAnswerQuestionReview';
import IPT from 'react-immutable-proptypes';
import EPT from 'edrolo/propTypes';
import PT from 'prop-types';

export const QuestionTypeSelection = ({
  question,
  solution,
  responses,
  classStudentProfiles,
  highlightProfileId,
  studentCourseProgUrl = () => {},
  insights,
}) => {
  const questionType = question.get('question_type');

  switch (questionType) {
    case EXAM_QUESTION_TYPES.SINGLE_ANSWER_MULTI_CHOICE: {
      return (
        <CorrectableQuestionReview
          question={question}
          solution={solution}
          responses={responses}
          highlightProfileId={highlightProfileId}
          classStudentProfiles={classStudentProfiles}
          nameColumn={name(studentCourseProgUrl)}
          studentResponseColumnSpec={{
            id: 'studentResponse',
            Header: 'Student Response',
            accessor: (row) => row.get('answer') || '',
            sortType: 'alphanumeric',
          }}
          answeredCorrectlyColumn={{
            ...answeredCorrectly,
          }}
          selfReflectionColumn={{ ...selfReflection }}
          showChart
          showCorrectness
        />
      );
    }
    case EXAM_QUESTION_TYPES.TEXT_CHECKLIST: {
      return (
        <ChecklistQuestionReview
          question={question}
          solution={solution}
          responses={responses}
          highlightProfileId={highlightProfileId}
          getStudentCourseProgressUrl={studentCourseProgUrl}
          classStudentProfiles={classStudentProfiles}
        />
      );
    }
    case EXAM_QUESTION_TYPES.TEXT: {
      return (
        <ShortAnswerQuestionReview
          question={question}
          solution={solution}
          responses={responses}
          highlightProfileId={highlightProfileId}
          getStudentCourseProgressUrl={studentCourseProgUrl}
          classStudentProfiles={classStudentProfiles}
          insights={insights}
        />
      );
    }

    case EXAM_QUESTION_TYPES.WORKED_ANNOTATED_IMAGE: {
      return (
        <WorkedChecklistQuestionReview
          question={question}
          solution={solution}
          responses={responses}
          highlightProfileId={highlightProfileId}
          getStudentCourseProgressUrl={studentCourseProgUrl}
          classStudentProfiles={classStudentProfiles}
        />
      );
    }
    case EXAM_QUESTION_TYPES.WORKED: {
      return (
        <WorkedQuestionReview
          question={question}
          solution={solution}
          responses={responses}
          highlightProfileId={highlightProfileId}
          getStudentCourseProgressUrl={studentCourseProgUrl}
          classStudentProfiles={classStudentProfiles}
        />
      );
    }
    case EXAM_QUESTION_TYPES.NUMBER: {
      return (
        <CorrectableQuestionReview
          question={question}
          solution={solution}
          responses={responses}
          highlightProfileId={highlightProfileId}
          classStudentProfiles={classStudentProfiles}
          nameColumn={name(studentCourseProgUrl)}
          studentResponseColumnSpec={{
            id: 'studentResponse',
            Header: 'Student Response',
            style: { width: '20%' },
            accessor: (row) => row.get('answer') || '',
            sortType: 'alphanumeric',
          }}
          answeredCorrectlyColumn={{
            ...answeredCorrectly,
            style: { width: '22%' },
          }}
          selfReflectionColumn={{ ...selfReflection, style: { width: '15%' } }}
          showCorrectness
        />
      );
    }
    case EXAM_QUESTION_TYPES.SIMPLE_MATH: {
      return (
        <CorrectableQuestionReview
          question={question}
          solution={solution}
          responses={responses}
          highlightProfileId={highlightProfileId}
          classStudentProfiles={classStudentProfiles}
          nameColumn={name(studentCourseProgUrl)}
          studentResponseColumnSpec={{
            id: 'studentResponse',
            Header: 'Student Response',
            style: { width: '20%' },
            accessor: (row) => row.get('answer') || '',
            sortType: 'alphanumeric',
            Cell: (cell) => (
              <StaticEquation key={cell.row.id} equation={cell.value} />
            ),
          }}
          answeredCorrectlyColumn={{
            ...answeredCorrectly,
            style: { width: '22%' },
          }}
          selfReflectionColumn={{ ...selfReflection, style: { width: '15%' } }}
          showCorrectness
        />
      );
    }
    case EXAM_QUESTION_TYPES.NUMBER_ON_IMAGE: {
      return (
        <NumberOnImageQuestionReview
          question={question}
          solution={solution}
          responses={responses}
          highlightProfileId={highlightProfileId}
          studentCourseProgUrl={studentCourseProgUrl}
          classStudentProfiles={classStudentProfiles}
        />
      );
    }
    case EXAM_QUESTION_TYPES.COMPLEX: {
      return (
        <ComplexSolutionQuestionReview
          question={question}
          solution={solution}
          responses={responses}
          highlightProfileId={highlightProfileId}
          studentCourseProgUrl={studentCourseProgUrl}
          classStudentProfiles={classStudentProfiles}
        />
      );
    }
    case EXAM_QUESTION_TYPES.FILL_IN_BLANK: {
      return (
        <FillInBlankQuestionReview
          question={question}
          solution={solution}
          responses={responses}
          highlightProfileId={highlightProfileId}
          getStudentCourseProgressUrl={studentCourseProgUrl}
          classStudentProfiles={classStudentProfiles}
        />
      );
    }
    case EXAM_QUESTION_TYPES.DRAG_AND_DROP: {
      return (
        <DragAndDropQuestionReview
          question={question}
          solution={solution}
          responses={responses}
          highlightProfileId={highlightProfileId}
          getStudentCourseProgressUrl={studentCourseProgUrl}
          classStudentProfiles={classStudentProfiles}
        />
      );
    }
    case EXAM_QUESTION_TYPES.ILLUSTRATION: {
      return (
        <IllustrationQuestionReview
          question={question}
          solution={solution}
          responses={responses}
          highlightProfileId={highlightProfileId}
          classStudentProfiles={classStudentProfiles}
          getStudentCourseProgressUrl={studentCourseProgUrl}
        />
      );
    }
    case EXAM_QUESTION_TYPES.SELECT_MULTI: {
      return (
        <CorrectableQuestionReview
          question={question}
          solution={solution}
          responses={responses}
          highlightProfileId={highlightProfileId}
          classStudentProfiles={classStudentProfiles}
          nameColumn={name(studentCourseProgUrl)}
          studentResponseColumnSpec={{
            id: 'studentResponse',
            Header: 'Student Response',
            style: { width: '20%' },
            accessor: (row) => row.get('answer') || '',
            sortType: 'alphanumeric',
          }}
          selfReflectionColumn={{ ...selfReflection, style: { width: '15%' } }}
          answeredCorrectlyColumn={{
            ...answeredCorrectly,
            style: { width: '22%' },
          }}
          showChart
          showCorrectness
          isMultiChoiceMultiAnswer
        />
      );
    }
    default:
      return <UnsupportedQuestionType />;
  }
};

QuestionTypeSelection.propTypes = {
  question: EPT.ExamQuestion.isRequired,
  solution: IPT.contains({
    solution: IPT.contains({
      exemplar_response_checklist_items: IPT.listOf(
        IPT.contains({
          id: PT.number.isRequired,
          description: PT.string.isRequired,
        })
      ),
    }),
  }).isRequired,
  responses: IPT.listOf(EPT.ExamResponse),
  classStudentProfiles: IPT.orderedMapOf(
    IPT.contains({
      user_id: PT.number.isRequired,
      profile_id: PT.number.isRequired,
      first_name: PT.string.isRequired,
      last_name: PT.string.isRequired,
      display_name: PT.string,
      is_active: PT.bool,
    })
  ),
  highlightProfileId: PT.number,
  insights: PT.object,
};
